export enum LoginType {
  IOA = 'ioa',
  TencentCloud = 'tencent_cloud'
}

export enum TencentCloudLoginType {
  Wechat = 'wechat',
  QQ = 'qq'
}

export enum SubSystemType {
  SubAccount = 'SubAccount',
}

export type TencentCloudAccountOwnerInfo = {
  account: string;
  checkStatus: string | null;
  displayName: string;
  email: string;
  emailFlag: number;
  isDefaultOwner: boolean;
  phone: string;
  phoneFlag: number;
  subSystemType: SubSystemType;
  subUserName: string;
  uin: string;
  userName: string;
  extAttr: {
    needResetStoken: boolean;
    needResetToken: boolean;
  }
};

export type TencentCloudAccount = {
  uin: string;
  ownerInfo: TencentCloudAccountOwnerInfo[]
};

export type TencentCloudToken = {
  expireTimestamp: number;
  key: string;
  ownerUin: string;
  sid: string;
  uin: string;
};
